import React from 'react';
import { useTranslation } from '../components/TranslationContext';
import { Helmet } from 'react-helmet';
import '../styles/equipe.css';
import '../styles/root.css';
import equipeImage1 from '../assets/usine/Marine & Moi-85.jpg';
import equipeImage2 from '../assets/usine/Marine & Moi-67.jpg';
import equipeImage3 from '../assets/usine/Marine & Moi-68.jpg';
import equipeImage4 from '../assets/usine/Marine & Moi-70.jpg';
import equipeImage5 from '../assets/usine/Marine & Moi-69.jpg';
import equipeImage6 from '../assets/usine/Marine & Moi-75.jpg';
import equipeImage7 from '../assets/usine/Marine & Moi-71.jpg';
import equipeImage8 from '../assets/usine/Marine & Moi-72.jpg';
import equipeImage9 from '../assets/usine/Marine & Moi-74.jpg';

const Equipe = () => {
  const { translate } = useTranslation();
  const equipe = translate('equipe');

  return (
    <>
      <Helmet>
        <title>Marine & Moi - L'Équipe</title>
        <meta name="description" content="Rencontrez l'équipe de Marine & Moi, votre partenaire de confiance dans le textile premium." />
        <meta name="keywords" content="équipe, textile, premium, partenaire, confiance" />
      </Helmet>
      <h1 className="team-title">{equipe.teamTitle}</h1>
      <div className="gallery">
        <div className="gallery-item">
          <img src={equipeImage1} alt={equipe.member1} />
          <div className="overlay">
            <h3>{equipe.member1}</h3>
            <p>{equipe.role1}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage2} alt={equipe.member2} />
          <div className="overlay">
            <h3>{equipe.member2}</h3>
            <p>{equipe.role2}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage3} alt={equipe.member3} />
          <div className="overlay">
            <h3>{equipe.member3}</h3>
            <p>{equipe.role3}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage4} alt={equipe.member4} />
          <div className="overlay">
            <h3>{equipe.member4}</h3>
            <p>{equipe.role4}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage5} alt={equipe.member5} />
          <div className="overlay">
            <h3>{equipe.member5}</h3>
            <p>{equipe.role5}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage6} alt={equipe.member6} />
          <div className="overlay">
            <h3>{equipe.member6}</h3>
            <p>{equipe.role6}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage7} alt={equipe.member7} />
          <div className="overlay">
            <h3>{equipe.member7}</h3>
            <p>{equipe.role7}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage8} alt={equipe.member8} />
          <div className="overlay">
            <h3>{equipe.member8}</h3>
            <p>{equipe.role8}</p>
          </div>
        </div>
        <div className="gallery-item">
          <img src={equipeImage9} alt={equipe.member9} />
          <div className="overlay">
            <h3>{equipe.member9}</h3>
            <p>{equipe.role9}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Equipe;
